import localFont from 'next/font/local';

export const mainFont = localFont({
  src: [
    {
      path: './reader-bold-italic.ttf',
      weight: '700',
      style: 'italic',
    },
    {
      path: './reader-bold.ttf',
      weight: '700',
      style: 'normal',
    },
    {
      path: './reader-italic.ttf',
      weight: '400',
      style: 'italic',
    },
    {
      path: './reader-medium-italic.ttf',
      weight: '500',
      style: 'italic',
    },
    {
      path: './reader-regular.ttf',
      weight: '400',
      style: 'normal',
    },
    {
      path: './reader-medium.ttf',
      weight: '500',
      style: 'normal',
    },
  ],
  display: 'swap',
  variable: '--font-main',
});

export const logoFont = localFont({
  src: [
    {
      path: './FKGroteskNeue-Black.ttf',
      weight: '900',
      style: 'normal',
    },
  ],
  display: 'swap',
  variable: '--font-logo',
});

export const fontClasses = `${mainFont.variable} ${logoFont.variable}`;
